import { createRef, FC, useState, useEffect } from 'react';
import { CaretDown } from 'phosphor-react';
import { findSelectedAddonCategoryByKey } from '../../../helper/cms';
import { ShopContent, AddonCategory } from '../../../types/cms_shared_types';

interface AddonCategoryPickerMobileProps {
  selectedAddonCategoryKey?: string;
  addonCategories: AddonCategory[];
  cmsShopContent: ShopContent;
  switchAddonCategory: (selectedAddonCategoryKey: string) => void;
}

export const AddonCategoryPickerMobile: FC<AddonCategoryPickerMobileProps> = ({
  selectedAddonCategoryKey,
  addonCategories,
  cmsShopContent,
  switchAddonCategory,
}) => {
  const wrapperRef = createRef<HTMLInputElement>();

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);

  return (
    <div ref={wrapperRef} className="z-0 text-left">
      <button
        id="menu-button"
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="inline-flex px-4 py-2 border rounded-lg group sm:justify-center hover:text-text-gray border-input-border"
      >
        <div className="w-32 mr-2 text-sm font-medium truncate text-sami-dark group-hover:text-text-gray">
          {selectedAddonCategoryKey !== undefined
            ? findSelectedAddonCategoryByKey(selectedAddonCategoryKey, addonCategories)?.name ?? ''
            : cmsShopContent.addonsStep.pickSubcategorySelectText}
        </div>
        <CaretDown size={16} weight="bold" className="self-center text-text-gray" />
      </button>

      <div
        hidden={!isOpen}
        role="menu"
        className="absolute z-10 mt-2 origin-top-right bg-white rounded-md shadow-md right-4 ring-1 ring-black ring-opacity-5 focus:outline-none"
      >
        <div>
          {addonCategories.map((addonCategory, index) => {
            return (
              <div
                key={index}
                onClick={() => {
                  switchAddonCategory(addonCategory.key);
                  setIsOpen(false);
                }}
                className="flex justify-start px-4 py-3 text-sm truncate text-sami-dark hover:bg-input-gray hover:cursor-pointer"
              >
                {addonCategory.name}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
